import { render, staticRenderFns } from "./secondResultsDetail.vue?vue&type=template&id=522471f2&scoped=true&"
import script from "./secondResultsDetail.vue?vue&type=script&lang=js&"
export * from "./secondResultsDetail.vue?vue&type=script&lang=js&"
import style0 from "./secondResultsDetail.vue?vue&type=style&index=0&id=522471f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522471f2",
  null
  
)

export default component.exports